import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ApiService } from '../services/api.service';

interface Customer {
  id: number;
  name?: string;
  email?: string;
  phone?: string;
  company?: string;
  qBO_Customer_Id?: number;
}

@Component({
  standalone: true,
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.css',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule
  ]
})
export class CustomersComponent implements OnInit {
  dataSource = new MatTableDataSource<Customer>([]);
  displayedColumns: string[] = ['name', 'email', 'phone', 'company'];
  loading: boolean = true;
  error: string | null = null;

  @ViewChild(MatSort) set matSort(s: MatSort) {
    if (s) { this.dataSource.sort = s; }
  }

  @ViewChild(MatPaginator) set matPaginator(p: MatPaginator) {
    if (p) { this.dataSource.paginator = p; }
  }

  constructor(
    private router: Router,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadCustomers();
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  loadCustomers(): void {
    this.loading = true;
    this.error = null;
    
    console.log('Loading customers from API...');
    
    this.apiService.get<any>('customer/all').subscribe({
      next: (data) => {
        console.log('API Response received:', data);
        console.log('Response type:', typeof data);
        console.log('Is Array?', Array.isArray(data));
        
        // Handle if data is wrapped in an object
        let customersArray: any[];
        if (Array.isArray(data)) {
          customersArray = data;
        } else if (data && data.customers) {
          customersArray = data.customers;
        } else if (data && data.data) {
          customersArray = data.data;
        } else if (data && data.value) {
          customersArray = data.value;
        } else {
          console.error('Unexpected response format:', data);
          customersArray = [];
        }
        
        console.log('Customers array to display:', customersArray);
        console.log('Number of customers:', customersArray.length);
        
        // Map the response to handle both camelCase and PascalCase
        const customers = customersArray.map(c => ({
          id: c.id || c.Id,
          name: c.name || c.Name,
          email: c.email || c.Email,
          phone: c.phone || c.Phone,
          company: c.company || c.Company,
          qBO_Customer_Id: c.qBO_Customer_Id || c.QBO_Customer_Id
        }));
        
        this.dataSource.data = customers;
        this.loading = false;
        console.log('Customers loaded into table:', customers);
        console.log('Customers count:', customers.length);
        
        // Force change detection
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error loading customers:', err);
        console.error('Error status:', err.status);
        console.error('Error message:', err.message);
        
        if (err.status === 0) {
          this.error = 'Cannot connect to API. Make sure the Web API is running on https://localhost:44392 and SSL certificate is trusted.';
        } else if (err.status === 401) {
          this.error = 'Unauthorized. Please log out and log in again.';
        } else if (err.status === 404) {
          this.error = 'API endpoint not found. Check the API URL and endpoint.';
        } else {
          this.error = `Failed to load customers: ${err.message || 'Unknown error'}`;
        }
        
        this.loading = false;
        
        // Force change detection
        this.cdr.detectChanges();
      }
    });
  }

  createNewCustomer(): void {
    this.router.navigate(['/customers/new']);
  }

  viewCustomer(customer: Customer): void {
    this.router.navigate(['/customers', customer.id]);
  }

  editCustomer(customer: Customer): void {
    this.router.navigate(['/customers', customer.id]);
  }
}
